import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useToasts } from "react-toast-notifications";
import MsgBoxSelect from "../MsgBoxSelect/msg-box-select.component";
import Button from "../Button/button.component";
import { getAccessToken } from "../../helpers/functions";
import {
	ModalHeader,
	ModalDescription,
	ModalContentSeperator,
	ModalButtonContainer,
	ModalButton,
} from "../MsgBoxModal/styles";

Modal.setAppElement("#root");

const InternetRegistrationsModal = ({ isOpen, onClose, onSubmit }) => {
	const [enquiryType, setEnquiryType] = useState(null);
	const [selectedOffice, setSelectedOffice] = useState(null);
	const [offices, setOffices] = useState([]);
	const [loading, setLoading] = useState(false);
	const [officesLoading, setOfficesLoading] = useState(false);
	const { addToast } = useToasts();

	const enquiryTypeOptions = [
		{ label: "Sales", value: "SalesApplicant" },
		{ label: "Lettings", value: "LettingsApplicant" },
	];

	useEffect(() => {
		if (isOpen) {
			fetchOffices();
		}
	}, [isOpen]);

	const fetchOffices = async () => {
		try {
			const token = await getAccessToken();
			const url = `${process.env.REACT_APP_API_URL}utilities/reapitoffices`;

			const response = await fetch(url, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			if (response.ok) {
				const data = await response.json();

				// Filter active offices and format for dropdown
				const activeOffices = data
					.filter((office) => office.active === true)
					.map((office) => ({
						label: office.name,
						value: office.id,
					}));

				setOffices(activeOffices);
			} else {
				console.error("Failed to fetch offices");
				addToast("Failed to load offices", {
					appearance: "error",
					autoDismiss: true,
				});
			}
		} catch (error) {
			console.error("Error fetching offices:", error);
			addToast("Failed to load offices", {
				appearance: "error",
				autoDismiss: true,
			});
		}
	};

	const handleSubmit = async () => {
		if (!enquiryType || !selectedOffice) {
			addToast("Please select both enquiry type and office", {
				appearance: "error",
				autoDismiss: true,
			});
			return;
		}

		setLoading(true);
		try {
			await onSubmit({
				enquiryType: enquiryType.value,
				officeId: selectedOffice.value,
			});
		} finally {
			setLoading(false);
		}
	};

	const handleClose = () => {
		setEnquiryType(null);
		setSelectedOffice(null);
		onClose();
	};

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={handleClose}
			style={{
				content: {
					overflow: "visible",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "500px",
					maxWidth: "90vw",
				},
				overlay: {
					backgroundColor: "rgba(0,0,0,0.7)",
				},
			}}
		>
			<ModalHeader>Send to Internet Registrations</ModalHeader>
			<ModalDescription>
				Select the enquiry type and office to send this conversation to
				internet registrations.
			</ModalDescription>
			<ModalContentSeperator />

			<div style={{ marginBottom: "20px" }}>
				<MsgBoxSelect
					label="Enquiry Type"
					options={enquiryTypeOptions}
					onChange={setEnquiryType}
					value={enquiryType}
					placeholder="Select enquiry type..."
					isLoading={false}
				/>
			</div>

			<div style={{ marginBottom: "20px" }}>
				<MsgBoxSelect
					label="Office"
					options={offices}
					onChange={setSelectedOffice}
					value={selectedOffice}
					placeholder="Select office..."
					isLoading={officesLoading}
				/>
			</div>

			<ModalButtonContainer>
				<ModalButton
					buttonName="Cancel"
					onClick={handleClose}
					primary={false}
				/>
				<ModalButton
					buttonName="Go"
					onClick={handleSubmit}
					primary={true}
					loading={loading}
					disabled={!enquiryType || !selectedOffice || loading}
				/>
			</ModalButtonContainer>
		</Modal>
	);
};

export default InternetRegistrationsModal;
